export enum BindTargetByCodeTypesEnum {
  BindFeedback = 'BindFeedback',
  Status = 'Status',
}

export type BindTargetByCodeStatus = {
  type: BindTargetByCodeTypesEnum.Status
  board_key: string
  code: string
}

export type BindTargetByCodeBind = {
  type: BindTargetByCodeTypesEnum.BindFeedback
  board_key: string
}

export enum BindTargetStatus {
  Pending = 'pending',
  Success = 'success',
  Expired = 'expired',
}

export type BindTargetByCode = BindTargetByCodeStatus | BindTargetByCodeBind

export type BindTargetByCodeRes = { code?:string, status?: BindTargetStatus }
